import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, RefreshCw } from "lucide-react";
import { LogoMark } from "../components/chat/Logo";
import { StatCards } from "../components/admin/StatCards";
import { DailyChart } from "../components/admin/DailyChart";
import { RecentTable } from "../components/admin/RecentTable";
import { SourceCard } from "../components/admin/SourceCard";
import { adminApi } from "../lib/admin";

export default function AdminDashboard() {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await adminApi.get("/admin/stats");
      setData(res.data);
    } catch {
      nav("/admin/login", { replace: true });
    } finally {
      setLoading(false);
    }
  }, [nav]);

  useEffect(() => {
    load();
  }, [load]);

  const logout = async () => {
    await adminApi.post("/auth/logout").catch(() => {});
    nav("/admin/login", { replace: true });
  };

  if (!data) return <div className="ad-page grid place-items-center text-[#9DB0A5]" data-testid="admin-loading">Carregando...</div>;

  return (
    <div className="ad-page" data-testid="admin-dashboard">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 py-6 sm:py-10 space-y-4">
        <header className="flex items-center gap-3 mb-4">
          <LogoMark size={52} />
          <div className="flex-1 min-w-0">
            <h1 className="ad-h1">Painel de cliques</h1>
            <p className="text-xs text-[#9DB0A5]">Leads únicos por opção escolhida no chat</p>
          </div>
          <button data-testid="admin-refresh" onClick={load} className="ad-icon" aria-label="Atualizar">
            <RefreshCw size={17} className={loading ? "animate-spin" : ""} />
          </button>
          <button data-testid="admin-logout" onClick={logout} className="ad-icon" aria-label="Sair">
            <LogOut size={17} />
          </button>
        </header>
        <StatCards data={data} />
        <div className="grid lg:grid-cols-5 gap-4">
          <div className="lg:col-span-3"><DailyChart daily={data?.daily} /></div>
          <div className="lg:col-span-2"><RecentTable items={data?.recent} /></div>
        </div>
        <SourceCard sources={data?.sources} apps={data?.apps} />
      </div>
    </div>
  );
}
